import { apiClient } from "@nabble/sdk";
import { AuthHeader, AuthLayout, Button, Field, Icon, TextInput } from "@nabble/ui";
import { type FormEvent, useState } from "react";
import { Link } from "react-router-dom";

export default function ForgotPasswordPage(): React.JSX.Element {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent): Promise<void> {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      // Always shows the same confirmation, whether or not the email exists.
      await apiClient("/api/auth/password-reset", { method: "POST", body: { email: email.trim() } });
    } catch {
      // Same confirmation on errors too: never reveal whether an account exists.
    } finally {
      setLoading(false);
      setSent(true);
    }
  }

  return (
    <AuthLayout>
      {sent ? (
        <>
          <AuthHeader
            icon="mail"
            iconTone="success"
            title="Check your email"
            lead={
              <>
                If <strong>{email.trim()}</strong> has a Nabble Suite account, we sent it a link to reset your password. It may take a few
                minutes.
              </>
            }
          />
          <div className="nb-auth-content">
            <p className="nb-help">Didn't get it? Check your spam folder or ask your administrator for help.</p>
          </div>
        </>
      ) : (
        <>
          <AuthHeader title="Get back into your account" lead="Enter your email and we'll send you a link to create a new password." />
          <form className="nb-auth-content" onSubmit={(e) => void submit(e)} noValidate>
            <Field label="Email">
              <TextInput
                icon="mail"
                type="email"
                autoComplete="username"
                inputMode="email"
                autoCapitalize="none"
                spellCheck={false}
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Field>
            <Button type="submit" label="Send link" size="lg" block loading={loading} disabled={!email.trim()} />
          </form>
        </>
      )}
      <div className="nb-auth-foot">
        <Link to="/login" className="nb-auth-back">
          <Icon name="arrowLeft" />
          Back to sign in
        </Link>
      </div>
    </AuthLayout>
  );
}
